/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CanceledInputs */

const en_canceled = /** @type {(inputs: CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const de_canceled = /** @type {(inputs: CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgesagt`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canceled = /** @type {((inputs?: CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_canceled(inputs)
	return de_canceled(inputs)
});